<template>
  <div class="flex-row align-items-center gap-xs">
    <button
        data-dusk="go-back"
        @click="goBack"
        class="go-back btn-transparent back-outline"
    >
      <ChevronLeftIcon class="icon-size-lg"></ChevronLeftIcon>
      terug
    </button>
    <dd-bread-crumbs
        v-if="hasBreadCrumbs"
        :bread-crumbs="breadCrumbs" >
    </dd-bread-crumbs>
  </div>
</template>

<script>
export default {
  name: "BackButton.vue",
  props: {
    redirectTo: {
      type: String,
    },
    breadCrumbs: {
      type: Array,
      required: false,
    },
    backHandler: {
      type: Function,
      required: false,
    },
  },
  computed: {
    hasBreadCrumbs() {
      return this.breadCrumbs && this.breadCrumbs.length > 0;
    },
    hasClickListener() {
      return this.backHandler;
    }
  },
  methods: {
    goBack() {
      if (this.hasClickListener) {
        this.backHandler();
      } else if (this.redirectTo) {
        this.navigator.navigatePath(this.redirectTo);
      } else {
        this.navigator.back();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

button.go-back.back-outline {
  background-color: transparent;
  border: 1px solid $brand-primary;
  color: $brand-primary;
  border-radius: $spacing-xs;
  padding-right: $spacing-xs;
};
button.go-back {
  color: $brand-primary;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: $font-size-base;
}
</style>
